module.exports = __webpack_public_path__ + "29fbe54036234d03683b701ad1996a0d.png";